<template>
  <div class="push-approval-waiting text-center mt-3">
    <div class="separator my-2">hoặc</div>
    <!-- Phase 07: state "chờ duyệt" - hiện khi CHƯA armed autofill countdown -->
    <div v-if="!autoCompleteArmed">
      <div class="d-flex justify-content-center align-items-center">
        <div class="lds-ring push-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <span class="ml-2 font-size-14">Mở app eDoc và duyệt yêu cầu đăng nhập</span>
      </div>
      <!-- Phase 02: đếm ngược TTL (remainingSeconds truyền từ cha, cập nhật mỗi lần poll). -->
      <div v-if="remainingSeconds > 0" class="countdown font-size-12 mt-1">
        Yêu cầu hết hạn sau {{ countdownText }}
      </div>
    </div>
    <!-- Push Autofill UX (Phase 08 - 2026-08-14): overlay countdown khi armed. KONGMING MUST-FIX #1
         deadline-based (cha giữ AutoCompleteController pure module, chỉ pass remaining tick vào đây).
         aria-live tách khỏi số tick (span role="timer") để screen reader KHÔNG spam mỗi giây. -->
    <div v-if="autoCompleteArmed" class="push-autocomplete-arm mt-2" aria-live="polite">
      <div class="d-flex justify-content-center align-items-center mb-2">
        <div class="lds-ring push-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <span class="ml-2 font-size-14">
          Đã duyệt trên điện thoại. Tự đăng nhập sau
          <span role="timer" aria-atomic="true">{{ autoCompleteRemaining }}s</span>
        </span>
      </div>
      <div class="d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-sm btn-primary mr-2"
          @click="$emit('confirm-now')"
        >
          Đăng nhập ngay
        </button>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          @click="$emit('cancel-auto')"
        >
          Huỷ
        </button>
      </div>
    </div>
    <!-- Push Autofill UX edge case: user Huỷ + allowTotpFallback=false (không rơi được về OTP tay).
         Attempt approved còn TTL Redis 600s -> nút "Đăng nhập ngay" cho user không kẹt. -->
    <div v-if="showLoginNowButton" class="text-center mt-2">
      <button
        type="button"
        class="btn btn-sm btn-warning"
        @click="$emit('login-now')"
      >
        Đăng nhập ngay
      </button>
      <div class="countdown font-size-12 mt-1">
        Yêu cầu đã duyệt vẫn còn hiệu lực trong vài phút.
      </div>
    </div>
  </div>
</template>

<script>
// Phase 07 (Push Approval login-web): phần "chờ duyệt qua app" hiện SONG SONG với ô nhập OTP
// (UC8 không đổi). Component này CHỈ hiển thị trạng thái + emit events - polling / autofill controller /
// complete-login do component cha (DangNhap.vue) điều phối để dễ dừng khi user gõ OTP (đường a) hoặc khi
// approved (đường b) mà không rò rỉ interval qua nhiều component.
//
// Phase 08 Push Autofill UX (2026-08-14): 3 UI state mới + 3 event emit (KONGMING MUST-FIX + extra):
//   State: autoCompleteArmed (overlay countdown), autoCompleteRemaining (tick số), showLoginNowButton (edge fallback=false)
//   Emit: confirm-now (user bấm OK), cancel-auto (user bấm Huỷ), login-now (edge case click)
export default {
  name: "PushApprovalWaiting",
  props: {
    // Phase 02: số giây còn lại TTL Redis (BE = nguồn sự thật, cha cập nhật mỗi poll). 0 -> ẩn đếm ngược.
    remainingSeconds: {
      type: Number,
      default: 0,
    },
    // Phase 08: overlay countdown autofill đang hiện (cha arm sau khi poll thấy approved + delay>0).
    autoCompleteArmed: {
      type: Boolean,
      default: false,
    },
    // Phase 08: số giây tick UI (cha tính từ AutoCompleteController deadline). 0 -> đã hoàn tất / cancel.
    autoCompleteRemaining: {
      type: Number,
      default: 0,
    },
    // Phase 08: hiện nút "Đăng nhập ngay" edge case (user Huỷ + allowTotpFallback=false).
    showLoginNowButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // mm:ss có pad 0; <=0 -> "00:00".
    countdownText() {
      const s = Number.isFinite(this.remainingSeconds) && this.remainingSeconds > 0
        ? Math.floor(this.remainingSeconds)
        : 0;
      const mm = Math.floor(s / 60);
      const ss = s % 60;
      return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
    },
  },
};
</script>

<style lang="scss" scoped>
// Reskin OTP (Phase 6): overlay token. Giữ props/computed/emit (component push-approval riêng common-fe - RT-2).
.push-approval-waiting {
  font-family: var(--otp-sans);
  .separator {
    font-size: 12px;
    color: var(--otp-muted);
  }
  .countdown {
    color: var(--otp-muted);
  }
  .push-spinner {
    position: static;
    display: inline-block;
    width: 20px;
    height: 20px;
    div {
      width: 16px;
      height: 16px;
      margin: 2px;
      border-width: 2px;
    }
  }
  .push-autocomplete-arm {
    padding: 10px;
    border-radius: var(--otp-radius-sm);
    background: var(--otp-success-bg);
    color: var(--otp-success);
  }
}
</style>
